// Dependency
import React, { useEffect, useState } from 'react';
import {Link} from "gatsby";
import axios from 'axios';

// Internationalization
import { useTranslation } from 'react-i18next';

// Components
import CartList from './cart-list/cart-list';
//import CartSuggest from './cart-suggest/cart-suggest';
import CartBanner from './cart-banner/cart-banner';
import CartFooter from './cart-footer/cart-footer';
import Marquee from "../marquee";
import { useCart } from '../../contexts/cart-context';
import Loader from '../loader/loader-overlay';
import Upsell from "./cart-suggest/upsell";

// Styles
import * as styles from './mini-cart.module.scss';
import * as cartFooterStyles from './../mini-cart/cart-footer/cart-footer.module.scss';

// Assets
import iconClose from './assets/icon-close.svg';
import iconCart from './assets/cart.png';

// Template
const MiniCart = (props) => {
  const { cart, miniCartOpen, toggleMiniCart, isLoading} = useCart();
  const [ upsellProds, setUpsellProds ] = useState([]);
  const [miniCart, setMiniCart] = useState(false);

  // Translation Function
  const { t } = useTranslation();

  useEffect(() => {
    setMiniCart(cart);
    //Todo check if country change and delay ajax until right lang is set
    if ( cart.token && cart.selection.items.length > 0 ) {
      const cartIds = [];
      cart.selection.items.map((item) => {
        cartIds.push(item.product.product)
      })
      axios.defaults.headers['post']['Accept'] = `*/*;api-token: ${cart.token}`
      axios({
        method: 'post',
        url: `${process.env.CENTRA_URL_PRODUCTS}`,
        data: {products: cartIds, relatedProducts: true}
      }).then(response => {

        let products = [];
        response.data.products.map((product) => {
          product.relatedProducts.map((relProd) => {
            if ( ! cartIds.includes(relProd.product) ) products.push(relProd);
          })
        })

        setUpsellProds(products);
      }).catch((error) => {
        console.log(error);
      });
    }
  }, [cart])

  useEffect(() => {
    setMiniCart(cart);
  }, [cart])

  return (
    <div className={`${styles.miniCart} ${miniCartOpen ? styles.isOpen : ''}`}>
      <button className={`${styles.miniCart__overlay}`} onClick={() => {toggleMiniCart()}}>
        <div className={`${styles.miniCart__close}`} >
          <span>
            <img src={iconClose} alt="Close Mini Cart" />
          </span>
          {t('miniCart.continueShopping')}
        </div>
      </button>
      <div className={`${styles.miniCart__content}`}>
        <Loader active={isLoading} />
        <header className={`${styles.miniCart__header}`}>
          <button className={`${styles.miniCart__close}`} onClick={() => {toggleMiniCart()}}>
            <span>
              <img src={iconClose} alt="Close Mini Cart" />
            </span>
          </button>
          <div className={`${styles.miniCart__topbar}`}>
            {t('miniCart.youCart')}
            <div className={styles.cdMinicartIcon}>
              <span>{miniCart && miniCart.selection.totals.totalQuantity ? miniCart.selection.totals.totalQuantity : 0}</span>
            </div>
          </div>
        </header>
        <div className={styles.cdMinicartMiddle}>
          {miniCart && miniCart.selection.items.length > 0 ? <div>
            <CartList />

            {/*Upsell*/}
            {upsellProds.length > 0 ? <Upsell upsell={upsellProds} country={props.country} />  : ''}
            {/* <CartSuggest country={props.country} /> */}
          </div>
              :
              <div className={styles.cdMinicartEmpty}>
                <h4>{t('miniCart.empty')}.</h4>
                <a className="button" onClick={() => {toggleMiniCart()}}>{t('miniCart.continueShopping')}</a>
              </div>
          }
        </div>
      </div>
      {miniCart && miniCart.selection.items.length > 0 && <CartFooter country={props.country} cname={`${miniCartOpen ? cartFooterStyles.isOpen : ''}`} />}
    </div>
  );
};

export default MiniCart;